import type React from 'react';
import { memo } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeGrid } from 'react-window';

import { Platform } from '../../../types/common.js';
import IntegrationCard from '../../_molecules/IntegrationCard/index.js';
import IntegrationCardOmni from '../../_molecules/IntegrationCardOmni/IntegrationCardOmni.jsx';

type Props = {
  filteredIntegrations: Platform[];
  onIntegrateButtonClick: (integrationId: number) => void;
};

const MARGIN_GAP = 150;
const COLUMN_COUNT = 4;

const GridCell = ({
  style,
  item,
  onIntegrateButtonClick,
}: {
  style: React.CSSProperties;
  item: Platform;
  onIntegrateButtonClick: (integrationId: number) => void;
}) => {
  if (!item) {
    return null;
  }

  return (
    <div style={style}>
      <div className="w-[calc(100%-24px)]">
        {item.isOmni ? (
          <IntegrationCardOmni integration={item} />
        ) : (
          <IntegrationCard
            integration={item}
            onIntegrateButtonClick={onIntegrateButtonClick}
          />
        )}
      </div>
    </div>
  );
};

const PlatformListContainer = ({
  filteredIntegrations,
  onIntegrateButtonClick,
}: Props) => {
  const rowCount = Math.ceil(filteredIntegrations.length / COLUMN_COUNT);

  return (
    <AutoSizer>
      {({ height: containerHeight, width: containerWidth }) => (
        <div
          style={{
            height: containerHeight - MARGIN_GAP,
          }}
          className="relative"
        >
          <FixedSizeGrid
            columnCount={COLUMN_COUNT}
            columnWidth={containerWidth / COLUMN_COUNT}
            height={containerHeight - MARGIN_GAP}
            rowCount={rowCount}
            rowHeight={234}
            width={containerWidth}
            style={{
              overflowX: 'hidden',
            }}
          >
            {({ rowIndex, style, columnIndex }) => (
              <GridCell
                {...{
                  rowIndex,
                  style,
                  columnIndex,
                  item: filteredIntegrations[
                    rowIndex * COLUMN_COUNT + columnIndex
                  ],
                  onIntegrateButtonClick,
                }}
              />
            )}
          </FixedSizeGrid>
        </div>
      )}
    </AutoSizer>
  );
};

export default memo(PlatformListContainer);
